import React from 'react'
import css from './style.scss'
import moment from 'moment'
import {Row} from './sections/utils'
import GeneralSection from './sections/general'
import TotalSection from './sections/total'
import ImpressionsPerDay from './sections/impressionsPerDay'
import StoriesPerDay from './sections/storiesPerDay'
import Streak from './sections/streak'
import BestStory from './sections/bestStory'
import BestDay from './sections/bestDay'
import TotalTime from './sections/totalTime'
import Exits from './sections/exits'
import Taps from './sections/taps'
function processData(stories, startDate, endDate) {
    let dateArray = [];
    let currentDate = moment(startDate).startOf("day");
    let stopDate = moment(endDate).startOf("day");
    while (currentDate <= stopDate) {
        let thisDate=moment(currentDate).startOf("day")
        currentDate = moment(currentDate).add(1, 'days').startOf("day")
        let st=stories.filter(s=> moment(s.posted_at).isSame(thisDate, "day"))
        dateArray.push({day:thisDate, stories: st, count:st.length})
    }
    return dateArray;
}

class Stats extends React.Component{
  constructor(props){
    super(props)
    this.state={
      data:[],
    }
  }

  componentDidMount(){
    this.setState({data:processData(this.props.stories, this.props.startDate, this.props.endDate)})
  }

  componentWillReceiveProps(props){
    this.setState({data:processData(props.stories, props.startDate, props.endDate)})
  }

  render(){
    return (
      <div>
        <Row>
          <GeneralSection className={css.column} stories={this.props.stories} startDate={this.props.startDate} endDate={this.props.endDate}/>
          <ImpressionsPerDay className={css.column} data={this.state.data} stories={this.props.stories} startDate={this.props.startDate} endDate={this.props.endDate} />
        </Row>
        <Row>
          <TotalTime adventure={this.props.adventure} account_name={this.props.account_name} className={css.column} stories={this.props.stories}/>
          <TotalSection className={css.column} stories={this.props.stories}/>
        </Row>
        <Row>
          <BestDay className={css.column} data={this.state.data} stories={this.props.stories} startDate={this.props.startDate} endDate={this.props.endDate}/>
          <BestStory className={css.column} data={this.state.data} stories={this.props.stories} startDate={this.props.startDate} endDate={this.props.endDate}/>
        </Row>
        <Row>
          <Exits adventure={this.props.adventure} className={css.column} stories={this.props.stories}/>
          <Taps adventure={this.props.adventure} className={css.column} stories={this.props.stories}/>
        </Row>
        {!this.props.adventure &&
          <Row>
            <StoriesPerDay  account_name={this.props.account_name} className={css.column} data={this.state.data} stories={this.props.stories} startDate={this.props.startDate} endDate={this.props.endDate} />
            <Streak  account_name={this.props.account_name} className={css.column} data={this.state.data} stories={this.props.stories} startDate={this.props.startDate} endDate={this.props.endDate} />
          </Row>
        }
      </div>
    )
  }
}
export default Stats;



// WEBPACK FOOTER //
// ./src/components/account_page/stats/stats.js